import React, { memo } from 'react'
import { Center, Flex, useColorModeValue, Spinner, Text } from '@chakra-ui/react'

import { SearchTab } from 'types'
import { sortBy } from 'lodash'
import { PropertyCategory, SearchLocationQuery } from 'generated/graphql'
import { useBrowserStorage } from 'hooks'
import { RECENT_SEARCHED_LOCATIONS_STORAGE_KEY } from '../../../constants'
import SuggestionItem from './SuggestionItem'
import { getUniqValuesArr } from 'utils'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

type SuggestionBoxProps = {
  searchTerm: string
  tab: PropertyCategory
  selectItems: SearchTab[]
  searchFocus: boolean
  results: SearchLocationQuery | undefined
  loading: boolean
  onClick?: (items: SearchTab) => void
}
const Wrap = styled(Flex)`
  flex-direction: column;
  position: absolute;
  top: 100%;
  left: 0;
  border-radius: 0 0 8px 8px;
  width: 100%;
  overflow-y: auto;
  max-height: 50vh;
  z-index: 47393844;
`

const SuggestionBox: React.FC<SuggestionBoxProps> = ({
  onClick,
  searchFocus,
  searchTerm,
  tab,
  results,
  selectItems,
  loading
}) => {
  const bg = useColorModeValue('white', 'gray.700')
  const border = useColorModeValue('gray.100', 'gray.600')
  const { t } = useTranslation()
  let areas: SearchTab[] = sortBy(
    results?.searchLocation?.map((location) => ({
      ...location,
      tab
    })) as SearchTab[],
    '_key'
  )

  areas = getUniqValuesArr<SearchTab>(areas, selectItems)
  const [localRecentSearch] = useBrowserStorage<SearchTab[]>(
    RECENT_SEARCHED_LOCATIONS_STORAGE_KEY,
    'local',
    []
  )
  const recents = localRecentSearch
    ? getUniqValuesArr<SearchTab>(localRecentSearch, selectItems)
    : []
  return searchTerm ? (
    <Wrap bg={bg} border="1px solid" borderColor={border}>
      {loading ? (
        <Center p={6}>
          <Spinner color="gray" size="sm" />
        </Center>
      ) : (
        areas?.map((options, idx) => (
          <React.Fragment key={idx}>
            <SuggestionItem {...options} onClick={onClick} />
          </React.Fragment>
        ))
      )}
    </Wrap>
  ) : searchFocus && recents.length > 0 ? (
    <Wrap bg={bg} border="1px solid" borderColor={border}>
      <Text px={4} py={2} fontSize="xs" fontWeight="semibold">
        {t('recently_searched')}
      </Text>
      {recents?.map((options, idx) => (
        <React.Fragment key={idx}>
          <SuggestionItem key={idx} {...options} onClick={onClick} />
        </React.Fragment>
      ))}
    </Wrap>
  ) : (
    <></>
  )
}

export default memo(SuggestionBox)
